module.exports = "/images/pallet_thumb.png?ae87b19948ce516dfe0c9eb9e11eb504";